export const PostEmail = 'https://projectapi.gostareshaliazhtandis.com/api/owner/sendEmail'
export const ownerLogin = 'https://projectapi.gostareshaliazhtandis.com/api/owner/Login'
export const getusers = 'https://projectapi.gostareshaliazhtandis.com/api/users'
export const getProduct = 'https://projectapi.gostareshaliazhtandis.com/api/products'
export const getProductById = 'https://projectapi.gostareshaliazhtandis.com/api/products/id/'
export const getStory = 'https://projectapi.gostareshaliazhtandis.com/api/Story'
export const getComments = 'https://projectapi.gostareshaliazhtandis.com/api/comments'
export const searchProducts = 'https://projectapi.gostareshaliazhtandis.com/api/products/search'